import { cn } from '@/lib/utils';

interface CustomerAddressDisplayItemProps {
	typeLabel?: string | null;
	summary?: string | null;
	fallbackTypeLabel?: string;
	fallbackSummary?: string;
	className?: string;
}

const compact = (value?: string | null) => {
	const normalized = value?.trim();
	return normalized ? normalized : null;
};

export function CustomerAddressDisplayItem({
	typeLabel,
	summary,
	fallbackTypeLabel = 'Address',
	fallbackSummary = 'Linked address',
	className
}: CustomerAddressDisplayItemProps) {
	const resolvedTypeLabel = compact(typeLabel) ?? fallbackTypeLabel;
	const resolvedSummary = compact(summary) ?? fallbackSummary;

	return (
		<div className={cn('bg-transparent', className)}>
			<p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
				{resolvedTypeLabel}
			</p>
			<p className="mt-1 break-words text-base text-foreground">
				{resolvedSummary}
			</p>
		</div>
	);
}
